import React from 'react';
import { useFetch } from 'bv-hooks';
import fetchEnabledLocales from 'Seo/api/fetch_enabled_locales';
import AlternateLanguagesRedux from './alternate_languages_redux';

const AlternateLanguagesContainer = () => {
  const [data, loading] = useFetch(fetchEnabledLocales);

  if (loading) return null;

  return <AlternateLanguagesRedux languages={data} />;
};

export default AlternateLanguagesContainer;
